<template>
  <div class="qty__table">
    <div class="qty__table-row">
      <div class="qty__table-cell qty__table-vertical-title" v-html="getAliquotsTitle"></div>
      <div class="qty__table-cell qty__table-horizontal" v-html="qtyTable.aliquots"></div>
      <div class="qty__table-cell"></div>
    </div>
    <div v-if="getQtyTableAliquotQty" class="qty__table-row">
      <div
        class="qty__table-cell qty__table-vertical-title"
        v-html="getQtyTableAliquotQtyTitle"
      ></div>
      <div class="qty__table-cell qty__table-horizontal" v-html="getQtyTableAliquotQty" />
      <div class="qty__table-cell qty__table-horizontal" v-html="getUOM" />
    </div>
    <div v-if="qtyTable.remainder" class="qty__table-row qty__table-remainder">
      <div class="qty__table-cell qty__table-vertical-title" v-html="getRemainderTitle"></div>
      <div class="qty__table-cell qty__table-horizontal" v-html="qtyTable.remainder" />
      <div class="qty__table-cell qty__table-horizontal" v-html="getUOM" />
    </div>
    <div v-if="qtyTable.qtyPerLot" class="qty__table-row qty__table-total">
      <div class="qty__table-cell qty__table-vertical-title" v-html="getTotalTitle"></div>
      <div class="qty__table-cell qty__table-horizontal" v-html="qtyTable.qtyPerLot" />
      <div class="qty__table-cell qty__table-horizontal" v-html="getUOM" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'ProductDetailsQtyTable',
  props: {
    qtyTable: {
      type: Object,
      required: true,
    },
    isCellProduct: {
      type: Boolean,
      required: true,
    },
    isBaseSkuSelected: {
      type: Boolean,
      required: true,
    },
    tableLabelUnit: {
      type: String,
      required: true,
      default: '',
    },
    volPerLotTableFieldTitle: {
      type: String,
      required: true,
      default: '',
    },
    aliquotQtyTableFieldTitle: {
      type: String,
      required: true,
      default: '',
    },
  },
  computed: {
    getTitleSuffix() {
      if (this.isBaseSkuSelected || !this.tableLabelUnit) {
        return (
          this.$t('product.admetox.qtyTable.individual') +
          ' / ' +
          this.$t('product.admetox.qtyTable.pool')
        )
      }
      return this.tableLabelUnit === 'IND'
        ? this.$t('product.admetox.qtyTable.individual')
        : this.$t('product.admetox.qtyTable.pool')
    },
    getAliquotsTitle() {
      const prefix = this.isCellProduct
        ? this.$t('product.admetox.qtyTable.vialsPer')
        : this.$t('product.admetox.qtyTable.aliquotsPer')
      return prefix + this.getTitleSuffix + ':'
    },
    getRemainderTitle() {
      const prefix = this.$t('product.admetox.qtyTable.remainderPer')
      return prefix + this.getTitleSuffix + ':'
    },
    getTotalTitle() {
      if (this.volPerLotTableFieldTitle) return `${this.volPerLotTableFieldTitle}:`
      const prefix = this.isCellProduct
        ? this.$t('product.admetox.qtyTable.cellsPer')
        : this.$t('product.admetox.qtyTable.volPer')
      return prefix + this.getTitleSuffix + ':'
    },
    getQtyTableAliquotQtyTitle() {
      if (this.aliquotQtyTableFieldTitle) return `${this.aliquotQtyTableFieldTitle}:`
      return this.isCellProduct
        ? this.$t('product.admetox.qtyTable.vialCells')
        : this.$t('product.admetox.qtyTable.aliquotVol')
    },
    getQtyTableAliquotQty() {
      return this.qtyTable.aliquotQty || this.qtyTable.qtyPerLot
    },
    getUOM() {
      return this.isCellProduct
        ? this.$t('product.admetox.qtyTable.cells')
        : this.$t('product.admetox.qtyTable.ml')
    },
  },
}
</script>
